import styled from 'styled-components';

export const MaintenanceContainerStyled = styled.div`
    background: rgba(255, 255, 255, 0.7);
    box-shadow: 0px 8px 30px rgba(67, 57, 126, 0.1);
    border-radius: 20px;
    width: 100%;
    padding: 48px 70px 66px;
    max-width: 70%;
    margin: 0 auto;
    font-family: var(--bllink-font-secondary);

    .label {
        color: #373647;
        text-align: start;
        width: 100%;
    }

    .top-container {
        display: grid;
        grid-template-rows: repeat(2, 1fr);
        grid-template-columns: repeat(2, 1fr);
        row-gap: 21px;
        column-gap: 30px;
        margin-bottom: 46px;
        
        .input {
            .bllink-input-border {
                background: #F3F1FF;
                border-radius: 10px;
                border: 1px solid #F3F1FF;
                height: 54px;
                font-size: 18px;
    
                :focus {
                    border: 1px solid #8764FF;
                }
            }
        }
    }

    .call-details {
        font-weight: 700;
        font-size: 22px;
        color: #373647;
        margin-bottom: 22px;
        text-align: start;
    }

    .middle-container {
        width: 100%;
        display: grid;
        gap: 30px;
        grid-template-columns: repeat(2, 1fr);

        .react-switch-selector-wrapper {
            height: 52px;
            direction: ltr;
        }

        .react-switch-selector-option-label {
            font-size: 18px;
            margin-bottom: 0;
        }
    }

    .bottom-container {
        margin-top: 21px;
        display: grid;
        grid-template-columns: 3fr 1fr;
        gap: 18px;

        .text-area {
            display: flex;
            flex-direction: column;

            textarea {
                background-color: #F3F1FF;
                border: none;
                border-radius: 10px;
                outline: none;
                resize: none;
                padding: 10px;

                :focus {
                    border: 1px solid #8764FF;
                }
            }
        }

        .upload-picture {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 22px;

            input {
                display: none;
            }

            .label {
                color: rgba(55, 54, 71, 0.7);
                font-weight: 700;
                font-size: 17px;
            }

            .upload {
                cursor: pointer;
            }
        }
    }

    .uploaded-files {
        display: flex;
        gap: 24px;
        margin: 25px 0;
        flex-wrap: wrap;

        .uploaded-image {
            position: relative;
            width: fit-content;

            .image {
                height: 110px;
                width: 194px;
                border: 1px solid rgba(110, 116, 255, 0.4);
                border-radius: 11px;
            }

            .overlay {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                height: 100%;
                width: 100%;
                opacity: 0;
                transition: .3s ease;
                background-color: rgba(55, 54, 71, 0.7);
                border-radius: 11px;
                color: white;
                padding: 3px 10px;
                font-size: 40px;
                cursor: pointer;

                img {
                    margin-top: -35px;
                }
            }
        }

        .uploaded-image:hover .overlay {
            opacity: 1;
        }

        .file-name {
            color: rgba(55, 54, 71, 0.7);
            font-size: 12px;
            margin-top: 9px;
        }
    }

    .app-btn {
        margin-top: 25px;
        height: 60px;
        position: relative;
        width: 220px;
        font-family: var(--bllink-font-headers);
        font-weight: 400;
        font-size: 20px;

        .arrow {
            position: absolute;
            right: ${({ ltr }) => ltr ? '10px' : ''};
            left: ${({ ltr }) => ltr ? '' : '10px'};
            transform: ${({ ltr }) => ltr ? 'rotate(180deg)' : ''};;
        }
    }

    @media screen and (max-width: 768px) {
        padding: 40px 22px 50px;
        max-width: none;
        width: 90%;

        .top-container {
            grid-template-rows: repeat(4, 1fr);
        }
        
        .top-container, .middle-container, .bottom-container {
            grid-template-columns: 1fr;            
        }

        .uploaded-files {
            gap: 18px;
            margin: 29px 0;
            justify-content: space-between;
    
            .uploaded-image {    
                .image {
                    height: 110px;
                    width: 110px;
                }
            }
        }

        .app-btn {
            height: 52px;
            margin-top: 25px;
            width: 100%;
        }
    }
`
